export const ACTIONS = {
  SET_TAB_INDEX: "SET_TAB_INDEX",
  SET_PROCESSING: "SET_PROCESSING",
  SET_PROFILE: "SET_PROFILE",
  SET_VALIDATION_ERRORS: "SET_VALIDATION_ERRORS",
  SET_NESTED_VALIDATION_ERRORS: "SET_NESTED_VALIDATION_ERRORS",

  // Form Values
  SET_FIELD: "SET_FIELD",
  SET_SKILLS: "SET_SKILLS",
  SET_JOB_TYPES: "SET_JOB_TYPES",

  // Experience
  ADD_EXPERIENCE: "ADD_EXPERIENCE",
  REMOVE_EXPERIENCE: "REMOVE_EXPERIENCE",
  UPDATE_EXPERIENCE: "UPDATE_EXPERIENCE",

  // Education
  ADD_EDUCATION: "ADD_EDUCATION",
  REMOVE_EDUCATION: "REMOVE_EDUCATION",
  UPDATE_EDUCATION: "UPDATE_EDUCATION",

  // Documents
  SET_RESUME: "SET_RESUME",
  SET_PROFILE_DOCUMENTS: "SET_PROFILE_DOCUMENTS",
  ADD_PROFILE_DOCUMENT: "ADD_PROFILE_DOCUMENT",
  REMOVE_PROFILE_DOCUMENT: "REMOVE_PROFILE_DOCUMENT",

  // Form Submit
  FORM_SUBMIT_START: "FORM_SUBMIT_START",
  FORM_SUBMIT_SUCCESS: "FORM_SUBMIT_SUCCESS",
  FORM_SUBMIT_FAILURE: "FORM_SUBMIT_FAILURE",
  FORM_SUBMIT_VALIDATION_ERRORS: "FORM_SUBMIT_VALIDATION_ERRORS",
  
  // Validation
  CLEAR_FIELD_ERROR: "CLEAR_FIELD_ERROR",
  SET_FIELD_ERROR: "SET_FIELD_ERROR",
  CLEAR_NESTED_FIELD_ERROR: "CLEAR_NESTED_FIELD_ERROR",
  SET_NESTED_FIELD_ERROR: "SET_NESTED_FIELD_ERROR",
};

// Reducer
export const ProfileFormReducer = (state, action) => {
  switch (action.type) {
    case ACTIONS.SET_TAB_INDEX:
      return { ...state, tabIndex: action.payload };
    case ACTIONS.SET_PROCESSING:
      return { ...state, processing: action.payload };
    case ACTIONS.SET_PROFILE:
      return { ...state, profile: action.payload };
    case ACTIONS.SET_VALIDATION_ERRORS:
      return { ...state, validation_errors: action.payload };
    case ACTIONS.SET_NESTED_VALIDATION_ERRORS:
      return { ...state, nested_validation_errors: action.payload };

    // Form Values
    case ACTIONS.SET_FIELD:
      return {
        ...state,
        profile: {
          ...state.profile,
          ...action.payload,
        },
      };

    // Add Experience
    case ACTIONS.ADD_EXPERIENCE:
      return {
        ...state,
        profile: {
          ...state.profile,
          experiences: [...state.profile.experiences, action.payload],
        },
        nested_validation_errors: {
          ...state.nested_validation_errors,
          experiences: [
            ...state.nested_validation_errors.experiences,
            {
              employer: null,
              title: null,
              start_date: null,
              end_date: null,
              description: null,
            },
          ],
        },
      };

    // Remove Experience
    case ACTIONS.REMOVE_EXPERIENCE:
      const newExperience = [
        ...state.profile.experiences.slice(0, action.payload),
        ...state.profile.experiences.slice(action.payload + 1),
      ];
      const newExperienceErrors = [
        ...state.nested_validation_errors.experiences.slice(0, action.payload),
        ...state.nested_validation_errors.experiences.slice(action.payload + 1),
      ];

      return {
        ...state,
        profile: {
          ...state.profile,
          experiences: newExperience,
        },
        nested_validation_errors: {
          ...state.nested_validation_errors,
          experiences: newExperienceErrors,
        },
      };

    // Update Experience
    case ACTIONS.UPDATE_EXPERIENCE: {
      const { index, experience } = action.payload;
      return {
        ...state,
        profile: {
          ...state.profile,
          experiences: state.profile.experiences.map((exp, i) =>
            i === index ? experience : exp
          ),
        },
      };
    }

    case ACTIONS.SET_SKILLS:
      return {
        ...state,
        profile: {
          ...state.profile,
          skills: action.payload,
          skill_ids: action.payload,
        },
      };

    // SET_JOB_TYPES
    case ACTIONS.SET_JOB_TYPES:
      return {
        ...state,
        profile: {
          ...state.profile,
          job_type_ids: action.payload,
        },
      };

    // Documents
    case ACTIONS.SET_RESUME:
      return {
        ...state,
        profile: {
          ...state.profile,
          resume: action.payload.resume,
          resume_file_name: action.payload.resume_file_name || action.payload.resume?.name || null,
        },
      };

    case ACTIONS.SET_PROFILE_DOCUMENTS:
      return {
        ...state,
        profile: {
          ...state.profile,
          profile_documents: action.payload,
        },
      };

    case ACTIONS.ADD_PROFILE_DOCUMENT:
      return {
        ...state,
        profile: {
          ...state.profile,
          profile_documents: [...(state.profile.profile_documents || []), action.payload],
        },
      };

    case ACTIONS.REMOVE_PROFILE_DOCUMENT:
      return {
        ...state,
        profile: {
          ...state.profile,
          profile_documents: (state.profile.profile_documents || []).filter(
            (doc, index) => index !== action.payload
          ),
        },
      };

    // Add Education
    case ACTIONS.ADD_EDUCATION:
      return {
        ...state,
        profile: {
          ...state.profile,
          educations: [...state.profile.educations, action.payload],
        },
        nested_validation_errors: {
          ...state.nested_validation_errors,
          educations: [
            ...state.nested_validation_errors.educations,
            {
              school_name: null,
              qualification: null,
              start_date: null,
              end_date: null,
              description: null,
            },
          ],
        },
      };

    // Remove Education
    case ACTIONS.REMOVE_EDUCATION:
      const newEducation = [
        ...state.profile.educations.slice(0, action.payload),
        ...state.profile.educations.slice(action.payload + 1),
      ];
      const newEducationErrors = [
        ...state.nested_validation_errors.educations.slice(0, action.payload),
        ...state.nested_validation_errors.educations.slice(action.payload + 1),
      ];

      return {
        ...state,
        profile: {
          ...state.profile,
          educations: newEducation,
        },
        nested_validation_errors: {
          ...state.nested_validation_errors,
          educations: newEducationErrors,
        },
      };

    // Update Education
    case ACTIONS.UPDATE_EDUCATION: {
      const { index, education } = action.payload;
      return {
        ...state,
        profile: {
          ...state.profile,
          educations: state.profile.educations.map((edu, i) =>
            i === index ? education : edu
          ),
        },
      };
    }

    // Form Submit
    case ACTIONS.FORM_SUBMIT_START:
      return { ...state, processing: true, error: false };
    case ACTIONS.FORM_SUBMIT_SUCCESS:
      return { ...state, processing: false, error: false };
    case ACTIONS.FORM_SUBMIT_FAILURE:
      return { ...state, processing: false, error: true };
    case ACTIONS.FORM_SUBMIT_VALIDATION_ERRORS:
      return { 
        ...state, 
        processing: false, 
        error: false,
        validation_errors: action.payload 
      };

    // Validation
    case ACTIONS.CLEAR_FIELD_ERROR:
      return {
        ...state,
        validation_errors: {
          ...state.validation_errors,
          [action.payload]: null,
        },
      };
    case ACTIONS.SET_FIELD_ERROR:
      return {
        ...state,
        validation_errors: {
          ...state.validation_errors,
          [action.payload.field]: action.payload.error,
        },
      };

    // Nested Validation
    case ACTIONS.CLEAR_NESTED_FIELD_ERROR: {
      const { type, index, field } = action.payload;
      const currentErrors = { ...state.nested_validation_errors };
      
      if (currentErrors[type] && currentErrors[type][index]) {
        currentErrors[type] = [...currentErrors[type]];
        currentErrors[type][index] = {
          ...currentErrors[type][index],
          [field]: null,
        };
      }
      
      return {
        ...state,
        nested_validation_errors: currentErrors,
      };
    }
    case ACTIONS.SET_NESTED_FIELD_ERROR: {
      const { type, index, field, error } = action.payload;
      const currentErrors = { ...state.nested_validation_errors };
      
      if (!currentErrors[type]) {
        currentErrors[type] = [];
      }
      
      // Ensure the array is long enough
      while (currentErrors[type].length <= index) {
        currentErrors[type].push({
          employer: null,
          title: null,
          start_date: null,
          end_date: null,
          description: null,
          school_name: null,
          qualification: null,
        });
      }
      
      currentErrors[type] = [...currentErrors[type]];
      currentErrors[type][index] = {
        ...currentErrors[type][index],
        [field]: error,
      };
      
      return {
        ...state,
        nested_validation_errors: currentErrors,
      };
    }

    default:
      return state;
  }
};
